import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors } from '../../constants'
import { settings } from '../../containers/Landing/LandingIconsWhite/index'

const MenuShortcut = styled.div`
    padding: 0 10px 0 0;
    transition: all 0.3s;

    ${({ active }) => active && `background: ${colors.bluelighter2}`}
`

const Shortcut = ({ active, onClick }) => (
    <MenuShortcut active={active} onClick={onClick}>
        <div className='settings-link'>
            <img src={settings} alt="settings-icon"/>
        </div>
    </MenuShortcut>
)

Shortcut.propTypes = {
    active: PropTypes.bool,
    onClick: PropTypes.func,
}

Shortcut.defaultProps = {
    active: false,
    onClick: () => null,
}

export default Shortcut
